import { PlainI18nProps } from "shared/types/i18n";

import { I18nProps } from "~/components/text";

export const i18nPropsHaveContent = (
  props?: I18nProps | PlainI18nProps,
): props is I18nProps | PlainI18nProps => {
  return !!(props?.text || props?.tx || props?.txUnchecked);
};
